<template>
  <div class="container">

    <div class="card">
      <section class="hero is-primary">
        <div class="hero-body">
          <div class="container">
            <h1 class="title">
              Properties
            </h1>
          </div>
        </div>
      </section>
    </div>

    <b-collapse
      class="card"
      :open="isFilterOpen"
    >
      <div
        slot="trigger"
        slot-scope="props"
        class="card-header"
      >
        <p class="card-header-title">
          Filter
        </p>
        <a class="card-header-icon">
          <b-tooltip
            label="Filter"
            position="is-left"
          >
            <div class="level-right button is-primary">
              <i :class="props.open ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" />
            </div>
          </b-tooltip>
        </a>
      </div>
      <div
        class="card-content"
        style="background-color: #FFFFDD"
      >
        <PropertyFilter />
      </div>
    </b-collapse>

    <b-collapse
      class="card"
      :open="isNewPropertyOpen"
    >
      <div
        slot="trigger"
        slot-scope="props"
        class="card-header"
      >
        <div class="card-header-title">

          <div class="column">
            <div
              class="button is-primary has-text-weight-normal"
              @click="() => { $store.state.isNewSinglefamilyProperty = true; $store.state.isNewMultifamilyProperty = false; }"
            >
              <i
                class="fas fa-home"
                style="margin-right: .3em"
              ></i>New Single-family Property
            </div>
            <div
              v-if="$store.getters.session.rights.preferred"
              class="button is-primary has-text-weight-normal"
              @click="() => { $store.state.isNewSinglefamilyProperty = false; $store.state.isNewMultifamilyProperty = true; }"
              style="margin-left: 10px"
            >
              <i
                class="fas fa-building"
                style="margin-right: .3em"
              ></i>New Multifamily Property
            </div>
          </div>

          <!-- <button class="button is-primary">New Property</button> -->
        </div>
        <a class="card-header-icon">
          <b-tooltip
            label="New Property"
            position="is-left"
          >
            <div class="level-right button is-primary">
              <i :class="props.open ? 'fas fa-chevron-up' : ' fas fa-chevron-down'"></i>
            </div>
          </b-tooltip>
        </a>
      </div>
      <div
        class="card-content"
        style="background-color: #FFFFDD"
      >
        <NewProperty />
      </div>
    </b-collapse>

    <div class="card">
      <div class="card-header">
        <div class="card-header-title">
          Properties
        </div>
      </div>
      <div class="card-content">
        <PropertyList />
      </div>
    </div>

  </div>
</template>

<script>
import PropertyFilter from "@/components/properties/PropertyFilter.vue";
import NewProperty from "@/components/properties/NewProperty.vue";
import PropertyList from "@/components/properties/PropertyList.vue";

export default {
  props: {
    open: true,
    crumbs: []
  },

  components: {
    PropertyFilter,
    NewProperty,
    PropertyList
  },

  data() {
    return {
      isFilterOpen: true,
      isNewPropertyOpen: false
    };
  },

  mounted() {
    this.autoOpenProperty();
  },

  methods: {
    autoOpenProperty() {
      if (this.$store.state.properties.length == 0)
        this.isNewPropertyOpen = true;
      this.isNewPropertyOpen = false;
    }
  }
};
</script>

<style>
</style>
